import React from 'react';
import { TabPanel } from '@spotify-internal/encore-web';
import { VideoCategoryHeader } from './VideoCategoryHeader';
import { useReduxVideos } from './useReduxVideos';

export const HeaderTabPanel = () => {
  const { videoCategories, videos } = useReduxVideos();
  return (
    <div className="new-videos encore-inverted-dark-set">
      {videoCategories.allSlugs.map((slug: string) => {
        const id = videoCategories.slugToId[slug];
        const category = videoCategories.byId[id];
        const video = videos.byId[category.featuredVideo];
        return (
          <TabPanel key={`${category.name}-panel-keyboard`} value={category.id}>
            <VideoCategoryHeader video={video} videoCategory={category} />
          </TabPanel>
        );
      })}
    </div>
  );
};
